// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const ESTQ_RESERVA_CABECALHO_ST = {
  Preconfigurada: 'ESTQ_RESERVA_CABECALHO_ST0',
  Ativa: 'ESTQ_RESERVA_CABECALHO_ST1',
  ParcialmenteConsumida: 'ESTQ_RESERVA_CABECALHO_ST2',
  Consumida: 'ESTQ_RESERVA_CABECALHO_ST3',
  Cancelada: 'ESTQ_RESERVA_CABECALHO_ST4',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    ESTQ_RESERVA_CABECALHO_ST0: 0,
    ESTQ_RESERVA_CABECALHO_ST1: 1,
    ESTQ_RESERVA_CABECALHO_ST2: 2,
    ESTQ_RESERVA_CABECALHO_ST3: 3,
    ESTQ_RESERVA_CABECALHO_ST4: 4
  }
}
